<template>
  <div class="full-width bg-white">
    <!-- label -->
    <div
      v-if="label"
      class="row items-center q-mb-sm text-caption text-capitalize"
    >
      <div :class="{ 'text-grey': !labelColor }" :style="{ color: labelColor }">
        {{ label }}
      </div>
      <div v-if="mandatory" class="text-red q-ml-xs">*</div>
      <div class="q-ml-md">
        <slot name="info"></slot>
      </div>
    </div>
    <!-- ... -->

    <!-- input -->
    <div class="border-full q-px-sm input" :class="{ disabled: disable }">
      <q-input
        v-model="model"
        :disable="disable"
        dense
        borderless
        mask="date"
        :placeholder="placeholder"
        input-class="text-dark text-weight-medium text-caption"
      >
        <template v-slot:append>
          <q-icon
            v-if="model && !disable"
            name="eva-close-outline"
            size="18px"
            color="grey"
            class="cursor-pointer q-mr-sm"
            @click="clearValue"
          />

          <q-icon
            name="eva-calendar-outline"
            class="cursor-pointer"
            size="20px"
          >
            <q-popup-proxy
              ref="date"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="model"
                :options="(date) => date >= min"
                minimal
                @input="() => $refs.date.hide()"
              />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <!-- ... -->
  </div>
</template>

<script>
export default {
  name: "TheSmartDate",

  props: {
    label: {
      type: String,
      default: "",
    },

    labelColor: {
      type: String,
      default: "",
    },

    mandatory: {
      type: Boolean,
      default: false,
    },

    disable: {
      type: Boolean,
      default: false,
    },

    value: {
      required: true,
      validator: (prop) => typeof prop === "string" || typeof prop === "object",
    },

    placeholder: {
      type: String,
      default: "",
    },

    min: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      model: null,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function () {
        if (this.value) {
          // console.log(this.value);
          this.model = this.$date.convertDateStringToDate(this.value);
        } else {
          this.model = "";
        }
      },
    },

    model() {
      this.$emit("input", this.model);
    },
  },

  methods: {
    clearValue() {
      this.model = "";
      this.$emit("input", this.model);
    },
  },
};
</script>

<style scoped>
.input >>> .q-field--dense .q-field__control {
  height: 38px;
}

.input >>> .q-field--dense .q-field__marginal {
  height: 38px;
}

.input >>> .q-field--dense .q-field__prepend {
  padding-right: 0px;
}
</style>
